/**
 * P0-10a — Control grants (tenant admin). Soft≠ invent.
 * CMC Settings AI surface — never /sa/* (SA caps live on SA Team desk).
 */
import { useState } from "react";
import { html, Field, Input, Card, Alert, KV } from "./ui.js";
import { useAction, useApi } from "./api.js";
import { useSession } from "./session.js";
import { envelopeSummary } from "./action-envelope.js";

const GRANTS_PATH = "/ai/autonomy/control-grants";
const CONTROL_CAPS = [
  "incident.observe",
  "incident.control",
  "incident.takeover",
  "autonomy.emergency_stop",
  "autonomy.policy.write",
];

export function ControlGrantsPanel({ toast }) {
  const { me } = useSession();
  const role = String((me && me.role) || "").toLowerCase();
  const adminOk = role === "admin" || role === "superadmin";
  const { data, error, reload } = useApi(adminOk ? GRANTS_PATH : null);
  const { run, busy, envelope } = useAction();
  const [username, setUsername] = useState("");
  const [picked, setPicked] = useState(["incident.observe", "incident.control"]);

  if (!adminOk) {
    return html`<${Alert} tone="info" title="Control grants"
      say="Only tenant admins assign Hold / Intervene / E-Stop grants. Users cannot open SA pages."/>`;
  }

  const items = (data && data.items) || [];
  const toggle = (cap) => {
    setPicked((cur) => (
      cur.includes(cap) ? cur.filter((c) => c !== cap) : [...cur, cap]
    ));
  };
  const save = async () => {
    const u = username.trim();
    if (!u) {
      toast && toast("Username required", "warn");
      return;
    }
    const capabilities = CONTROL_CAPS.filter((c) => picked.includes(c));
    const out = await run(GRANTS_PATH, {
      method: "PUT",
      body: { username: u, capabilities },
    });
    if (!out) {
      toast && toast("Grant save refused", "bad");
      return;
    }
    toast && toast("Control grant saved", "ok");
    setUsername("");
    reload && reload();
  };

  return html`
    <${Card} title="Control grants" lede="Tenant operators — not SA vault. Caps match the Team control plane (Hold / Takeover / E-Stop).">
      ${error ? html`<${Alert} tone="bad" title="Grants load failed" say=${String(error)}/>` : null}
      ${envelope
        ? html`<${KV} k="Last action" v=${envelopeSummary(envelope) || "—"} tone=${envelope.ok ? "hi" : "warn"}/>`
        : null}
      <div className="row gap">
        <${Field} label="Username">
          <${Input} value=${username} onInput=${(e) => setUsername(e.target.value)} placeholder="operator"/>
        </${Field}>
        <button type="button" className="btn" disabled=${busy} onClick=${save}>Save grant</button>
      </div>
      <div className="chips" style=${{ marginTop: 8 }}>
        ${CONTROL_CAPS.map((cap) => html`
          <button type="button" key=${cap} className="chip" data-sel=${picked.includes(cap) ? "1" : "0"}
            onClick=${() => toggle(cap)}>${cap}</button>`)}
      </div>
      <ul className="list compact">
        ${items.length === 0
          ? html`<li className="note">No grants yet — users stay observe-only (role floor).</li>`
          : items.map(
              (it) => html`<li key=${it.username}>
                <strong>${it.username}</strong>
                <span className="note"> · ${(it.capabilities || []).join(", ")}</span>
              </li>`
            )}
      </ul>
      <p className="note">SA staff caps remain on /sa/team — never exposed to tenant user. Durable store miss is 503, not mem Live.</p>
    </${Card}>
  `;
}
